export default __webpack_public_path__ + "static/media/blog1.ffe31c41.jpg";